import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PaymentIcon from "@mui/icons-material/Payment";
import { Card } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import { CustomerMessages } from "@/messages/customer/customer.messages";

type Props = {
  messages: CustomerMessages;
  disableNewPlan: boolean;
};

export function PlanManagementHeader({ messages, disableNewPlan }: Props) {
  const router = useNavigate();
  const { lang } = useLanguage();

  return (
    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <MDTypography variant="h5" fontWeight="bold">
        {messages.subscriptionManagementTabLabel}
      </MDTypography>

      <MDBox display="flex" gap={1}>
        <MDButton
          endIcon={<PaymentIcon />}
          variant="outlined"
          color="dark"
          onClick={() => router(ROUTE_URLS.companyPayments(lang))}
        >
          {messages.paymentsButton}
        </MDButton>

        <MDButton
          endIcon={<AddCircleOutlineIcon />}
          variant="gradient"
          color="dark"
          disabled={disableNewPlan}
          onClick={() => router(ROUTE_URLS.plans(lang))}
        >
          {messages.newPlanButton}
        </MDButton>
      </MDBox>
    </MDBox>
  );
}

export default PlanManagementHeader;
